import styles from "./ProductOrder.module.css";
import { useEffect, useMemo, useState } from "react";
import Spin from "../Spinner/Spinner";
import axios from "axios";
import { API } from "../../config";
import { useNavigate } from "react-router-dom";
import { FiShoppingCart, FiImage } from "react-icons/fi";
import { SearchInput } from "../ProductListing/Filters";

export const ProductOrder = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(search);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  const handleSearchChange = (value) => {
    setSearch(value);
  };

  const getProducts = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/Admin/cartOrders/products`, {
        params: {},
      });
      const data = response.data?.products ?? response.data;
      setProducts(
        Array.isArray(data) ? data : data && data.productId ? [data] : [],
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const productList = Array.isArray(products) ? products : [];
  
  const searchedProductLists = useMemo(() => {
    if (!productList) return [];
    if (!debouncedSearch) return productList;

    return productList.filter((p) =>
      p.productName.toLowerCase().includes(debouncedSearch.toLowerCase()),
    );
  }, [productList, debouncedSearch]);

  useEffect(() => {
    getProducts();
  }, []);

  if (loading) {
    return <Spin />;
  }


  return (
    <div className={styles.container}>
      <h1>Product wise Orders</h1>
      <p className={styles.subheading}>Browse orders organized by product</p>
      <SearchInput value={search} onChange={handleSearchChange} />
      <div className={styles.cardGrid}>
        {searchedProductLists?.length === 0 && (
          <p className={styles.noProducts}>No products found</p>
        )}
        {searchedProductLists?.map((p) => (
          <ProductCard
            key={p.productId}
            productName={p.productName}
            productImages={p.images ?? []}
            ordersCount={p.orderCount ?? 0}
            imagesCount={(p.images ?? []).length}
            handleClick={() => navigate(`${p.productId ?? ""}`)}
          />
        ))}
      </div>
    </div>
  );
};

const ProductCard = ({
  productImages = [],
  ordersCount = 0,
  imagesCount = 0,
  productName,
  handleClick,
}) => {
  const displayImages = productImages.slice(0, 3);

  return (
    <div className={styles.card} onClick={handleClick}>
      <div className={styles.cardImageSection}>
        <div className={styles.cardImagesRow}>
          {displayImages.length > 0 ? (
            displayImages.map((src, idx) => (
              <div key={idx} className={styles.cardImageWrap}>
                <img src={src} alt="" className={styles.cardImage} />
              </div>
            ))
          ) : (
            <div className={styles.cardImagePlaceholder}>No images</div>
          )}
        </div>
        <span className={styles.cardImageCountOverlay}>
          {imagesCount} image{imagesCount !== 1 ? "s" : ""}
        </span>
      </div>
      <div className={styles.cardInfo}>
        <h3 className={styles.cardTitle}>{productName || "-"}</h3>
        <div className={styles.cardStats}>
          <span className={styles.cardStatItem}>
            <FiShoppingCart className={styles.cardStatIcon} />
            {ordersCount} order{ordersCount !== 1 ? "s" : ""}
          </span>
          <span className={styles.cardStatItem}>
            <FiImage className={styles.cardStatIcon} />
            {imagesCount} image{imagesCount !== 1 ? "s" : ""}
          </span>
        </div>
      </div>
    </div>
  );
};
